import { ReactComponent as Edit } from 'assets/icons/icon-edit.svg';

export default Edit;
